import ActivityMetricsTable from './ActivityMetricsTable.component';

export default ActivityMetricsTable;
